
export const ExternalBotEvent = {
  ARTICLE_PAGE_INTERACTION: 'external.sys.article_page_interaction',
  CANCEL_SUPPORT_REQUEST: 'external.sys.cancel_support_request',
  APPLY_METADATA_AUTOMATION: 'external.sys.apply_metadata_automation',
  USER_SUBMIT_INPUT_TRANSACTION: 'external.user.submit_transaction',
  USER_SUBMIT_INPUT_TRANSACTION_FOR_AI: 'external.user.submit_transaction_for_ai',
  USER_MESSAGE_FOR_AI: 'external.user.message_for_ai',
  AI_MESSAGE_FOR_USER: 'external.ai.message_for_user',
} as const;

export type ExternalBotEventKind = typeof ExternalBotEvent[keyof typeof ExternalBotEvent]
